<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch01">
<a id="page18"></a>
<a id="page19"></a>
<div class="chapterHead">
<h2 class="chapterTitle"><span class="xrefInternal"><a href="#/xhtml/contents#ch_01"><span class="bold"><span class="smallCaps">ODE TO INSPIRATION</span></span></a></span></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse">Then the imagination withdraws, drifts across the table</p>
<p class="extractVerse">to investigate the glass flowers rolled in cloth tape.</p>
</div>
<div class="extract">
<p class="extractVerse">It hovers, probes the petals, some like galaxies,</p>
<p class="extractVerse">some like figs or seashells. Dutiful and penitent,</p>
</div>
<div class="extract">
<p class="extractVerse">it shimmers back across the gulf of air,</p>
<p class="extractVerse">without a metaphor, to doze away the afternoon.</p>
</div>
<div class="extract">
<p class="extractVerse">Rain.</p>
<p class="extractVerse">Unseasonably hot day.</p>
</div>
<div class="extract">
<p class="extractVerse">Imagination is the builder, the worker bee,</p>
<p class="extractVerse">but inspiration is the queen.</p>
</div>
<div class="extract">
<p class="extractVerse">And when she leaves me, where does she go</p>
<p class="extractVerse">if not back to the hive to gorge on royal jelly,</p>
</div>
<div class="extract">
<p class="extractVerse">back into her cave of winds, accumulating</p>
<p class="extractVerse">density, growing richer and darker,</p>
</div>
<div class="extract">
<p class="extractVerse">like mercury in the bloodstream,</p>
<p class="extractVerse">like extravagant honey.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter01.vue?20dd0a2c